interface action {
    type: string,
    payload: string,
}

const homeTimeInterval = (state = 'day', action: action) => {
    switch(action.type) {
        case 'SET_HOME_TIME_INTERVAL':
            return action.payload;
        default:
            return state;
    }
}

export default homeTimeInterval;